/**
 * Utility functions extracted from Home.tsx
 */

/**
 * Sort by order attribute using locale comparison
 */
export function sortByOrderAttribute(
  a: { order?: string },
  b: { order?: string }
): number {
  const orderA = (a.order || "").toUpperCase();
  const orderB = (b.order || "").toUpperCase();
  return orderA.localeCompare(orderB);
}

/**
 * Cleanup CSS classes from DOM elements
 */
export function cleanupClasses(
  tags: Array<{
    classList: {
      contains: (c: string) => boolean;
      remove: (c: string) => void;
    };
  } | null>
): void {
  for (const tag of tags) {
    if (tag?.classList.contains("rootClass")) {
      tag.classList.remove("rootClass");
    }
    if (tag?.classList.contains("superClass")) {
      tag.classList.remove("superClass");
    }
  }
}
